module.exports = __webpack_public_path__ + "img/Monitoring.818d6ec4.png";